import { render, staticRenderFns } from "./MovementsScreen.vue?vue&type=template&id=2e47a223&scoped=true&"
import script from "./MovementsScreen.vue?vue&type=script&lang=js&"
export * from "./MovementsScreen.vue?vue&type=script&lang=js&"
import style0 from "./MovementsScreen.vue?vue&type=style&index=0&id=2e47a223&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e47a223",
  null
  
)

export default component.exports